<template>

   <div class="cadfm-container-horizontal">
      <Left :lang="lang.Left"></Left>


  </div>
<!--
 <div class="cadfm-flexitem-fixed">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button  @click="settings" bold icon="cog" text="Settings" tooltip="Some tooltip for settings." :disabled="settingsButtonStatus"/>

        </b-navbar-nav>
      </action-bar>
      <action-content>


        <DashboardContent></DashboardContent>
      </action-content>
    </action-panel>

 </div>-->
</template>

<script>

import Left from '@/components/Dashboard/Views/DashboardWidgets/Left/Left'
//import DashboardContent from '@/components/Dashboard/Views/DashboardWidgets/DashboardContent'
//import Right from '@/components/Dashboard/Views/View_0/DashboardMenu'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'DashboardWidgets',
  components:{

    Left,
    //Right
  },
  data () {
    return {
      //settingsButtonStatus: false
    }
  },
  props:{
      
    lang: Object
  },
  created(){
      this.$store.dispatch("pm_deleteAllActiveFilters");
      this.$store.dispatch("pm_deleteAllActiveActions");
      this.$store.dispatch("lm_deleteAllActiveFilters");
      this.$store.dispatch("lm_deleteAllActiveActions");
  },
  methods: {



  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/DashboardWidgets.vue